import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { RequestLogResponse } from '../../responses/integration/request-log.response';

@Injectable({
  providedIn: 'root'
})
export class IntegrationLogService extends CommonService {

  constructor(private httpClient: HttpClient, configService:AppConfigService, private endpointBuilder: EndpointBuilderService) { super(configService); }

  public search(idUri?: number, idLogType?: number, datetimeInitRequest?: Date, pageIndex?: number, searchText?: string, idHealthUnit?: number): Observable<RequestLogResponse> {
    let uri = `IntegrationLog/GetAll?`

    if (idUri != null)
      uri = uri + `idUri=${idUri}&`;
    if (idLogType != null)
      uri = uri + `idLogType=${idLogType}&`;
    if (datetimeInitRequest != null)
      uri = uri + `datetimeInitRequest=${encodeURIComponent(datetimeInitRequest.toISOString())}&`;
    if (pageIndex != null)
      uri = uri + `pageIndex=${pageIndex}&`;
    if (searchText != null)
      uri = uri + `searchText=${searchText}&`;
    if (idHealthUnit != null)
      uri = uri + `idHealthUnit=${idHealthUnit}&`;

    return this.httpClient.get<RequestLogResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiIntegration) + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}